import { render, staticRenderFns } from "./RoundOverflowMenu.vue?vue&type=template&id=4df50220&"
import script from "./RoundOverflowMenu.vue?vue&type=script&lang=js&"
export * from "./RoundOverflowMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports